import Header from './components/Header';
import HeroSection from './components/HeroSection';
import SpotlightSection from './components/SpotlightSection';
import CommentsSection from './components/CommentsSection';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import FaqSection from './components/FaqSection';
import MediaSection from './components/MediaSection';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />

      <main>
        <HeroSection />

        <SpotlightSection />

        <CommentsSection />

        <section id="app" className="py-14 md:py-20 bg-background-100">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="bg-background-50 rounded-lg p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8 md:gap-12">
              <div className="flex-1 text-center lg:text-left">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
                  移动观影
                </h2>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg mb-4">
                  随时随地打开春夜影院，手机、平板完美适配。躺在床上、通勤路上、旅途中——让好电影陪你走过每一段时光。
                </p>
                <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4">
                  <a
                    href="#app"
                    onClick={(e) => e.preventDefault()}
                    className="inline-flex items-center gap-2 bg-foreground-900 hover:bg-foreground-800 text-background-50 font-medium px-5 py-2.5 rounded-md transition-colors whitespace-nowrap cursor-pointer text-sm"
                  >
                    <i className="ri-apple-fill text-lg"></i>
                    App Store
                  </a>
                  <a
                    href="#app"
                    onClick={(e) => e.preventDefault()}
                    className="inline-flex items-center gap-2 bg-foreground-900 hover:bg-foreground-800 text-background-50 font-medium px-5 py-2.5 rounded-md transition-colors whitespace-nowrap cursor-pointer text-sm"
                  >
                    <i className="ri-android-fill text-lg"></i>
                    Android 下载
                  </a>
                </div>
              </div>
              <div className="shrink-0">
                <div className="w-[220px] md:w-[260px] aspect-[9/16] rounded-lg overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Elegant%20smartphone%20mockup%20displaying%20cinematic%20movie%20streaming%20app%20interface%20with%20warm%20dark%20theme%2C%20film%20poster%20thumbnails%2C%20golden%20accent%20UI%20elements%2C%20sophisticated%20app%20design%2C%20rich%20amber%20tones%2C%20modern%20mobile%20layout%2C%20no%20text%2C%20clean%20presentation&width=520&height=920&seq=app-mockup-1&orientation=portrait"
                    alt="春夜影院移动端界面"
                    className="w-full h-full object-cover object-top rounded-lg"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <FeaturesSection />

        <RankingSection />

        <FaqSection />

        <MediaSection />

        <UpdatesSection />

        <TopicsSection />

        <IndexSection />

        <CardsSection />

        <section id="contact" className="py-14 md:py-20 bg-background-100">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="max-w-2xl mx-auto text-center">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
                联系我们
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
                如果你有任何关于春夜影院的建议、意见或合作意向，欢迎通过以下方式联系我们。我们重视每一位影迷的声音。
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                <div className="bg-background-50 rounded-lg p-5">
                  <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 mx-auto mb-3">
                    <i className="ri-mail-line text-accent-500 text-xl"></i>
                  </div>
                  <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-1">投稿邮箱</h3>
                  <p className="text-xs text-foreground-500">contact@chunye.net</p>
                </div>
                <div className="bg-background-50 rounded-lg p-5">
                  <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-secondary-100 mx-auto mb-3">
                    <i className="ri-wechat-line text-secondary-500 text-xl"></i>
                  </div>
                  <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-1">微信公众号</h3>
                  <p className="text-xs text-foreground-500">春夜影院</p>
                </div>
                <div className="bg-background-50 rounded-lg p-5">
                  <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 mx-auto mb-3">
                    <i className="ri-shake-hands-line text-primary-500 text-xl"></i>
                  </div>
                  <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-1">商务合作</h3>
                  <p className="text-xs text-foreground-500">biz@chunye.net</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="about" className="py-14 md:py-20 bg-background-50">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6 text-center">
                关于春夜
              </h2>
              <div className="bg-background-100 rounded-lg p-6 md:p-8 space-y-4">
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                  春夜影院成立于 2024 年，是一个致力于为影迷提供高品质免费观影体验的在线平台。我们相信，好的电影和剧集应该被更多人看到，而优质的观影体验不应该有门槛。
                </p>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                  平台汇聚超过 20,000 部影视资源，涵盖电影、电视剧、综艺、动漫、纪录片等全品类内容。我们坚持每日更新，确保你总能看到最新、最热的影视作品。蓝光画质配合智能加速技术，让你在任何网络环境下都能享受流畅的观影体验。
                </p>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                  春夜影院的团队由一群热爱电影的技术人和内容人组成。我们用心打磨每一个产品细节，从播放器的画质优化到页面加载速度，从内容分类的合理性到推荐算法的精准度——一切都是为了让你在春夜里，找到那部对味的电影。
                </p>
                <div className="flex flex-wrap gap-6 pt-2 text-sm text-foreground-500">
                  <span>20000+ 影视资源</span>
                  <span>每日更新</span>
                  <span>蓝光画质</span>
                  <span>无需注册</span>
                  <span>多端支持</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}